export default __webpack_public_path__ + "static/media/derpyHeadGif.2c8694be.gif";